import styled from '@emotion/styled';
import { Outlet } from 'react-router-dom';
import { changeSidebar } from '~/actions';
import { MOBILE_QRY } from '~/config';
import { useDispatch, useSelector } from '~/store';
import { selectIsSidebarOpen } from '~/store/slices/formSlice/selectors';
import Sidebar from './Sidebar';
import SideModal from './SideModal';
import MobileBottomNav from './MobileBottomNav';
import { createContext, useContext, useMemo, useState } from 'react';
import { useIsDesktop } from '../hooks/useIsDesktop';

export interface MobileCtaContextType {
  mobileCta: React.ReactNode;
  setMobileCta: (node: React.ReactNode) => void;
}

export const MobileCtaContext = createContext<MobileCtaContextType>({
  mobileCta: null,
  setMobileCta: () => {},
});

export const useMobileCta = () => useContext(MobileCtaContext);


const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  height: 100dvh;
  flex-direction: column-reverse;

  ${MOBILE_QRY} {
    flex-direction: row;
  }
`;

const SidebarContainer = styled.div`
  width: 300px;
  display: none;
  display: block;
  background-color: var(--white);
  border-right: 1px solid var(--border1);

  ${MOBILE_QRY} {
    display: block;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: var(--content1);
`;

const SidebarLayout = () => {
  const isSidebarOpen = useSelector(selectIsSidebarOpen);
 const isDesktop = useIsDesktop();
  const dispatch = useDispatch();
  const [mobileCta, setMobileCta] = useState<React.ReactNode>(null);
  const mobileCtaContextValue = useMemo(
  () => ({ mobileCta, setMobileCta }),
  [mobileCta]
);


  function onCloseSidebarModal() {
    dispatch(changeSidebar(false));
  }

  return (
    <MobileCtaContext.Provider value={mobileCtaContextValue}>
      <LayoutWrapper>
        <SidebarContainer>
          {isDesktop ? <Sidebar /> : <MobileBottomNav />}
          {/* Render the sidebar only if it's open or on desktop */}
          {/* <Sidebar /> */}
        </SidebarContainer>

        <SideModal
          size="sm"
          isOpen={!isDesktop && isSidebarOpen}
          onClose={onCloseSidebarModal}
          children={<Sidebar />}
          heading={{ text: 'createmyinvoice' }}
        />
        <ContentContainer>
          <Outlet />
        </ContentContainer>
        {/* {!isDesktop && <MobileBottomNav />} */}
      </LayoutWrapper>
    </MobileCtaContext.Provider>
  );
};

export default SidebarLayout;
